import { PropsWithChildren, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useCurrentUser } from "../hooks/useCurrentUser";

type StaffOnlyProps = PropsWithChildren<{ redirectTo?: string }>;

export function StaffOnly({ redirectTo, children }: StaffOnlyProps) {
  const { isCustomer, isStaff, user } = useCurrentUser();
  const navigate = useNavigate();

  useEffect(() => {
    const tenantId = user?.UserTenant[0]?.tenantId;
    if (isCustomer && tenantId) {
      navigate(redirectTo ?? `/o/${tenantId}`, { replace: true });
    }
  }, [isCustomer, navigate, redirectTo, user?.UserTenant]);

  if (!isStaff) {
    return <></>;
  }

  return <>{children}</>;
}
